/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 6/1/18
 * Copyright All Rights Reserved
 */

import { combineReducers } from 'redux';
import current from './currentUser';

const usersReducer = combineReducers({
  current,
});

export default usersReducer;



// WEBPACK FOOTER //
// ./js/reducers/usersReducer/index.js